export default __webpack_public_path__ + "static/media/Badge5.a5545b48.png";